module.exports = __webpack_public_path__ + "static/media/bag2.7c12bc6d.svg";